export default __webpack_public_path__ + "static/media/experience.681ab84b.svg";